/**
 * Used for VAPID, converts the VAPID public key into a byte format the browser accepts.
 */
export function urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding: string = '='.repeat((4 - (base64String.length % 4)) % 4);
    // eslint-disable-next-line no-useless-escape
    const base64: string = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData: string = window.atob(base64);
    const outputArray: Uint8Array = new Uint8Array(rawData.length);
    let i: number = 0;

    for (; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}
